enum Permission {
  SELL_RECRUITMENT = 'SELL_RECRUITMENT',
  SELL_PORTFOLIO = 'SELL_PORTFOLIO',
  CANCEL = 'CANCEL',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
  CONFIGURE_OFFER = 'CONFIGURE_OFFER',
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  ADMINISTRATE_DISCOUNTS = 'ADMINISTRATE_DISCOUNTS',
  ADMINISTRATE_BONUSES = 'ADMINISTRATE_BONUSES',
  VIEW_ENERGY_CONTRACTS = 'VIEW_ENERGY_CONTRACTS',
  ADMINISTRATE_ENERGY_CONTRACTS = 'ADMINISTRATE_ENERGY_CONTRACTS',
}

export default Permission
